interface Props {
  color: string | "#D0DEE6",
}
const Check = (props: Props) => {
  return (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="24" height="24" rx="12" fill="white"/>
    <path d="M17 8L10 16L7 13" stroke="#96BF47" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
  )
}
export default Check;
